<div>
  <div *ngIf="stage === 'categories'" class="create-ticket-title">Kategória választása</div>
  <div *ngIf="stage === 'categories'">
    <div *ngFor="let item of ticketCategories" class="cat-button" (click)="addCategory(item)">{{item.name}}</div>
  </div>

  <div *ngIf="stage === 'questions'" class="create-ticket-title">Attribútumok kitöltése</div>
  <div *ngFor="let item of ticketAttributes; let i = index;">
      <app-fill-ticket-attribute *ngIf="i === currentIndex && !skipping && stage === 'questions'" [attributes]="feature" [ticketAttribute]="item" [filledSubject]="attributeFilledSubject"></app-fill-ticket-attribute>
  </div>
  <div *ngFor="let item of ticketAttributesSkip; let i = index;">
      <app-fill-ticket-attribute *ngIf="i === currentIndex && skipping && stage === 'questions'" [ticketAttribute]="item" [filledSubject]="attributeFilledSubject"></app-fill-ticket-attribute>
  </div>

  <mat-form-field appearance="fill" *ngIf="stage === 'comments'">
    <mat-label>Megjegyzés</mat-label>
    <textarea rows="4" [(ngModel)]="description" matInput placeholder="Pl.: Az utca szélétől 2 méterre..."></textarea>
  </mat-form-field>

  <app-gallery-ticket *ngIf="stage === 'attachments'" [instance]="ticket"></app-gallery-ticket>

  <div class="action-buttons" [ngStyle]="{ marginTop: stage === 'comments' ? '20px' : 0 }">
    <app-button *ngIf="stepper[stage].done" [customColor]="'green'" [title]="'Befejez'" class="create-next-button" (click)="done()"></app-button>
    <app-button *ngIf="stepper[stage].forward" [customColor]="'yellow'" [title]="'Tovább'" class="create-end-button" (click)="go()"></app-button>
  </div>
  <div *ngIf="stepper[stage].skip && !unSkippable && !skipping && currentIndex === 0" class="create-skip-button" (click)="skip()">Kérdések átugrása</div>
  <div *ngIf="stepper[stage].cancel && !saved" class="create-cancel-button" (click)="cancel()">Mégsem</div>
</div>
